"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _jquery = _interopRequireDefault(require("jquery"));

var _tools = _interopRequireDefault(require("../libs/tools"));

var _debug = _interopRequireDefault(require("debug"));

var _fix = _interopRequireDefault(require("../common/fix"));

var _get = _interopRequireDefault(require("lodash/get"));

var _events = _interopRequireDefault(require("./events"));

var _device = _interopRequireDefault(require("../libs/device"));

var _es6ProxyPolyfill = _interopRequireDefault(require("es6-proxy-polyfill"));

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var log = (0, _debug.default)('core/component');
var EVETNS = Symbol("events");
var HASERROR = Symbol("haserror");
var createElement = _react.default.createElement;
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary

var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // const REACT_VERSION = new Version(React.version);
// 非手机浏览器下给所有组件添加onMouseDown事件

if (!_device.default.moblie) {
  _react.default.createElement = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    args[1] = Object.assign({}, args[1] || {});

    if ((0, _isArray.default)(args[1].className)) {
      args[1].className = (0, _classnames.default)(args[1].className);
    }

    if (args[0] == REACT_ELEMENT_TYPE || args[0] == REACT_STRICT_MODE_TYPE || args[0] == REACT_PROFILER_TYPE || args[0] == REACT_SUSPENSE_TYPE || args[0] == REACT_SUSPENSE_LIST_TYPE || args[0] == REACT_PORTAL_TYPE || args[0] == REACT_FRAGMENT_TYPE) {
      return createElement.apply(void 0, args);
    }

    var onmousedown = args[1] && args[1].onMouseDown;

    var onMouseDown = function onMouseDown(e) {
      try {
        var _e$nativeEvent;

        // if (e._dispatchListeners[0] === onMouseDown) {
        if (!(e !== null && e !== void 0 && (_e$nativeEvent = e.nativeEvent) !== null && _e$nativeEvent !== void 0 && _e$nativeEvent._dispatchMouseDown)) {
          e.nativeEvent._dispatchMouseDown = true;
          global.appContext.emit('window.mousedown', e.nativeEvent);
        } // }

      } catch (e) {
        // console.error(e)
        global.appContext.emit('window.mousedown', e.nativeEvent);
      }

      onmousedown && onmousedown(e);
    };

    args[1].onMouseDown = onMouseDown; // = $.extend({onMouseDown}, args[1]);

    if (args[0] == 'style' && args[1].child) {}

    var elem = createElement.apply(void 0, args);
    return elem;
  };
}
/**
 * 获取组件的上一级节点
 * @param fiber
 * @return {*}
 */


var getParent = function getParent(fiber) {
  try {
    if (fiber && fiber.return) {
      var sp = fiber.return;

      if (sp.stateNode instanceof Component) {
        return sp.stateNode;
      }

      return getParent(sp);
    } else {}
  } catch (ex) {
    console.error(ex);
  }

  return null;
};
/**
 * 检查事件名称
 * @param name
 * @param eventNames
 * @return {boolean}
 */


var checkNames = function checkNames(name, eventNames) {
  if (_tools.default.is_array(eventNames)) {
    for (var i in eventNames) {
      var val = eventNames[i];

      switch (_tools.default.type(val)) {
        case '[object String]':
          if (name === val) {
            return true;
          }

          break;

        case '[object RegExp]':
          if (val.test(name)) return true;
          break;
      }
    }
  }

  return false;
};
/**
 *
 */


var Component = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Component, _React$Component);

  /**
   *
   * @param props
   * @param context
   * @param updater
   */
  function Component(props, context, updater) {
    var _this;

    _this = _React$Component.call(this, props, context, updater) || this; //代理 componentDidMount 挂载结束后 会对事件进行处理

    _this.eventNames = [];
    _this[HASERROR] = false;

    _this.timeout = function (func, time) {
      if (process.env.NODE_ENV === 'development') console.warn(_this.constructor.name + " \u4E0D\u5EFA\u8BAE\u4F7F\u7528\u3010this.timeout\u3011\u8BF7\u4F7F\u7528 setTimeout");
      return setTimeout(function () {
        func.call(_assertThisInitialized(_this));
      }, time);
    };

    _this.interval = function (func, time) {
      if (process.env.NODE_ENV === 'development') console.warn(_this.constructor.name + " \u4E0D\u5EFA\u8BAE\u4F7F\u7528\u3010this.interval\u3011\u8BF7\u4F7F\u7528 setInterval");
      return setInterval(function () {
        func.call(_assertThisInitialized(_this));
      }, time);
    };

    _this.clear = function (val) {
      if (process.env.NODE_ENV === 'development') console.warn(_this.constructor.name + " \u4E0D\u5EFA\u8BAE\u4F7F\u7528\u3010this.clear\u3011\u8BF7\u4F7F\u7528 clearInterval \u6216 clearTimeout");
      clearTimeout(val);
      clearInterval(val);
    };

    _this._on = function (name, listener, caller) {
      if (caller === void 0) {
        caller = true;
      }

      // if (caller) {
      //     listener._debugID = this._reactInternalFiber._debugID;
      //
      // }
      var _name$split = name.split('.'),
          eventName = _name$split[0];

      if (checkNames(eventName, _this.eventNames)) {
        _this.events.addListener(name, listener);
      } else {
        var supFiber = getParent(_this._reactInternalFiber || _this._reactInternals);
        supFiber && supFiber._on(name, listener, false);
      }
    };

    _this._un = function (name, listener, caller) {
      if (caller === void 0) {
        caller = true;
      }

      // if (caller) {
      //     listener._debugID = this._reactInternalFiber._debugID;
      //
      // }
      var _name$split2 = name.split('.'),
          eventName = _name$split2[0];

      if (checkNames(eventName, _this.eventNames)) {
        _this.events.removeListener(name, listener);
      } else {
        var supFiber = getParent(_this._reactInternalFiber || _this._reactInternals);
        supFiber && supFiber._un(name, listener, false);
      }
    };

    _this._emit = function (name) {
      var _name$split3 = name.split('.'),
          eventName = _name$split3[0];

      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      if (checkNames(eventName, _this.eventNames)) {
        var _this$events;

        //log('_emit', name, args);
        (_this$events = _this.events).emit.apply(_this$events, [name].concat(args));
      } else {
        var supFiber = getParent(_this._reactInternalFiber || _this._reactInternals);
        supFiber && supFiber._emit.apply(supFiber, [name].concat(args));
      }
    };

    _this.componentDidMount = _this.componentDidMount || _tools.default.empty;
    _this.componentDidMount = new _es6ProxyPolyfill.default(_this.componentDidMount, {
      apply: function apply(target, self, args) {
        _jquery.default.each(self.$event, function (name, events) {
          _jquery.default.each(events, function (i, callback) {
            if (callback.initializer) {
              callback.value = callback.initializer.call(self);
            }

            self._on(name, callback.value);

            if (process.env.NODE_ENV === 'development') console.info(self.constructor.name, 'on ' + name);
          });
        });

        target.call.apply(target, [self].concat(args));
      }
    }); //代理 componentWillUnmount 卸载结束后 会对事件进行处理

    _this.componentWillUnmount = _this.componentWillUnmount || _tools.default.empty;
    _this.componentWillUnmount = new _es6ProxyPolyfill.default(_this.componentWillUnmount, {
      apply: function apply(target, self, args) {
        _jquery.default.each(self.$event, function (name, events) {
          _jquery.default.each(events, function (i, callback) {
            self._un(name, callback.value);

            if (process.env.NODE_ENV === 'development') console.info(self.constructor.name, 'un ' + name);
          });
        });

        target.call.apply(target, [self].concat(args));
      }
    });
    var proto = [].concat(Reflect.ownKeys(_assertThisInitialized(_this)), Reflect.ownKeys(_this.__proto__)).filter(function (v) {
      return v.toString().startsWith('_handler');
    });
    console.log(proto);

    for (var _iterator = _createForOfIteratorHelperLoose(proto), _step; !(_step = _iterator()).done;) {
      var name = _step.value;
      if (process.env.NODE_ENV === 'development') console.warn(_this.constructor.name + "." + name + " \u4E0D\u5EFA\u8BAE\u4F7F\u7528\u3010_handler\u3011\u4E3A\u524D\u7F00\u7684\u65B9\u6CD5\uFF0C\u8BF7\u4FEE\u6539\u4E3AES6\u7684\u7BAD\u5934\u51FD\u6570\uFF1B" + name.substr(1) + " = () => {}");
      _this[name] = _this[name].bind(_assertThisInitialized(_this));
    }

    return _this;
  }
  /**
   * react 15.x 开始生命周期可以捕获异常
   * @param error
   * @param info
   */


  var _proto = Component.prototype;

  _proto.componentDidCatch = function componentDidCatch(error, info) {
    this[HASERROR] = true;
    this.forceUpdate();
  }
  /**
   * @deprecated
   * @param func
   * @param time
   * @returns {number}
   */
  ;

  /**
   *
   * @param props
   * @param nextProps
   * @param update
   */
  _proto.extendPropsToState = function extendPropsToState(props, nextProps, update) {
    if (props === void 0) {
      props = {};
    }

    if (nextProps === void 0) {
      nextProps = {};
    }

    if (update === void 0) {
      update = false;
    }

    var pickStatus = {};
    var pickStatus2 = {};
    var pickProps = this.constructor.pickProps;

    _jquery.default.each(pickProps, function (key, val) {
      if (props[key] !== nextProps[key]) {
        var status = val === 1 ? pickStatus : pickStatus2;

        if (_tools.default.is_bool(pickProps[key])) {
          if (nextProps[key] == null && pickProps[key] === false) {
            return;
          }

          status[key] = nextProps[key];
        } else if (_tools.default.is_string(pickProps[key])) {
          status[pickProps[key]] = nextProps[key];
        } else {
          status[key] = nextProps[key];
        }
      }
    });

    if (!_tools.default.empty(pickStatus)) {
      this.state = _jquery.default.extend({}, this.state, pickStatus);
    }

    if (!_tools.default.empty(pickStatus2)) {
      this.state = _jquery.default.extend(true, {}, this.state, pickStatus2);
    }

    if (!(!_tools.default.empty(pickStatus) || !_tools.default.empty(pickStatus2)) && update !== false) this.setState({}, _tools.default.is_function(update) ? update : null);
  }
  /**
   *
   * @param name
   * @param listener
   * @param caller
   * @private
   */
  ;

  _createClass(Component, [{
    key: "events",
    get: function get() {
      if (this[EVETNS]) return this[EVETNS];
      this[EVETNS] = new _events.default(this);
      return this[EVETNS];
    }
  }, {
    key: "fix",
    get:
    /**
     *
     * @private
     */
    function get() {
      var fix = null;

      _react.default.Children.map(this.props.children, function (child) {
        if (_tools.default.is_object(child) && child.type === _fix.default) {
          if (child.props['type']) {
            fix = fix || {};
            fix[child.props['type']] = child.props.children;
          }
        } else if (_tools.default.is_object(child) && child.type === 'div') {
          if (child.props['data-fix']) {
            fix = fix || {};
            fix[child.props['data-fix']] = child.props.children;
          }
        }
      });

      return fix;
    }
  }]);

  return Component;
}(_react.default.Component);

var _default = Component;
exports.default = _default;
module.exports = exports.default;